import { Menu } from 'lucide-react';
import Header from '../Header';
import { Button } from '../ui/button';
import MenuList from '../Menu';
import { Outlet } from 'react-router';

type DashboardPageLayoutProps = {
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
};

export const DashboardPageLayout = ({ isMenuOpen, setIsMenuOpen }: DashboardPageLayoutProps) => {
  return (
    <>
      <Header
        menuTrigger={
          <Button
            variant="ghost"
            size="icon"
            className="-mr-2 flex h-8 w-8 items-center justify-center md:hidden"
            onClick={() => setIsMenuOpen(true)}>
            <Menu className="h-5 w-5" />
          </Button>
        }
      />
      <div className="relative mr-auto max-w-[1280px]">
        <MenuList isOpen={isMenuOpen} onOpenChange={setIsMenuOpen} />
        <div className="mt-20 md:ml-[250px]">
          <Outlet />
        </div>
      </div>
    </>
  );
};
